import React, {lazy, Suspense, useEffect} from "react";
import ReactDOM from "react-dom/client";
import Header from "./components/Header"
import Body from "./components/Body"
import About from "./components/About";
import Contact from "./components/Contact";
import Error from "./components/Error"; 
import RestuarantMenu from "./components/RestaurantMenu";
import { createBrowserRouter , RouterProvider, Outlet } from "react-router";
import UserContext from "./utils/userContext";
import { useState } from "react";
import { Provider } from "react-redux";
import appStore from "./utils/appStore";
import Cart from "./components/Cart";


const Grocery = lazy(()=> import("./components/Grocery"));

const AppLayout = () => {
    const[userName, setUserName] = useState();
    //authentication
    useEffect(()=>{
        //Make an API call and send Username and password
        const data={
            name : "Parshuram Kumar"
        };
        setUserName(data.name);
    },[])

    return ( //now as we have passed the setuserName so now we can use this variable also anywhere 
       <Provider store = {appStore}>
       <UserContext.Provider value={{loggedInUser : userName, setUserName}}>
        <div className = "app">
            <Header />
            <Outlet />
        </div>
        </UserContext.Provider>
        </Provider>
    )
}

const appRouter = createBrowserRouter([
  {  path : "/",
    element : <AppLayout />,
    children : [
        {
            path: "/" ,
            element : < Body/>,
        },
        {
            path : "/about",
            element : <About />,
        },
        {
            path : "/contact",
            element : <Contact />,
        },
        {
            path : "/restaurants/:resId",
            element : <RestuarantMenu />,
        },
        {
            path : "/grocery",
            element : <Suspense fallback = {<h1>Loading</h1>}><Grocery /></Suspense>,
        },
        {
            path : "/cart",
            element : <Cart />,
        }
    ],
    errorElement : <Error />
},
]);

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(<RouterProvider router={appRouter} />); 